"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getListCSVPath = exports.getListJsonPath = exports.getLawdataPath = void 0;
const path_1 = __importDefault(require("path"));
const getLawdataPath = (dataDir) => path_1.default.join(dataDir, "lawdata");
exports.getLawdataPath = getLawdataPath;
const getListJsonPath = (dataDir) => path_1.default.join(dataDir, "list.json");
exports.getListJsonPath = getListJsonPath;
const getListCSVPath = (dataDir) => path_1.default.join(dataDir, "lawdata", "all_law_list.csv");
exports.getListCSVPath = getListCSVPath;
//# sourceMappingURL=paths.js.map